import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSnackBarConfigComponent } from '../matSnackBarConfig/matSnackBarConfig.component';

@Component({
  selector: 'app-confirm-delete',
  templateUrl: './confirm-delete.component.html',
  styleUrls: ['./confirm-delete.component.scss']
})

export class ConfirmDeleteComponent {

  public confirmMessage: string;
  public naoExibeCancel: boolean;
  public confirmTitle: string = '';
  public textBtnConfirm: string = '';
  public textBtnCancel: string = '';
  public motivoCancelamento: string = '';
  public exibeIconCancel: boolean = true;
  confirmDeleteForm: UntypedFormGroup; 
  matSnackBarConf: any;
  estiloGreen: boolean = false;

  constructor( public dialogRef: MatDialogRef<ConfirmDeleteComponent>,
    @Inject(MAT_DIALOG_DATA) public _data: any,
    private _formBuilder: UntypedFormBuilder,
    private _matSnackBar: MatSnackBar,
   ) { 

    this.confirmTitle = _data?.confirmTitle ?? 'Confirmar';
    this.textBtnConfirm = _data?.textBtnConfirm ?? 'Confirmar';
    this.textBtnCancel = _data?.textBtnCancel ?? 'Cancelar';
    this.confirmMessage = _data?.confirmMessage ?? '';
    this.motivoCancelamento = _data?.nomeCampos?.[0] ?? '';

    this.confirmDeleteForm = this.createConfirmDeleteForm();
    this.matSnackBarConf = new MatSnackBarConfigComponent();

  }

  createConfirmDeleteForm(): UntypedFormGroup {

    return this._formBuilder.group({
        motivoCancelamento: "",
    });
  }

  fecharModalMotivoCancelamento(){

    if(this.confirmDeleteForm.get("motivoCancelamento").value && this.confirmDeleteForm.get("motivoCancelamento").value != ""){
      this.dialogRef.close([true, this.confirmDeleteForm]);
    } else {
      this._matSnackBar.open("Para cancelar este relatório é obrigatório preencher o campo!", "OK", this.matSnackBarConf.returnMatSnackBarConfig("warning"));
    }
    
  }

}
